<template>
	<div class="foot-component">
		<div class="foot-container w1360">
			<!-- <router-link tag="div" class="logo-link" :to="{ path: '/index', hash: 'top'  }" >
				<img class="logo" src="@/assets/logo.png" alt="" @click.prevent="toHome()" />
			</router-link> -->
			<div class="fields">
				<div class="label" @click="tohangye">行业网站</div>
				<div class="fields-item" @click="tohangye">{{ webInfo.copyright }}</div>
				<!-- <div class="menu">
					<router-link tag="div" class="menu-item" :to="{ path: '/feedback/index' }">意见反馈</router-link>
					<router-link tag="div" class="menu-item" :to="{ path: '/about/index', hash: 'pingtaijieshao'  }">平台介绍</router-link>
				</div> -->
				<!-- <div class="fields-item">联系方式：{{ webInfo.email }}</div> -->
			</div>
			<div class="contacts">
				<div class="label">联系我们</div>
				<div class="item">
					<div class="icon">
						<!-- <img src="@/assets/phone.png" alt="" /> -->
						<svg-icon name="phone"></svg-icon>
					</div>
					<div class="value">010-84535100</div>
				</div>
				<div class="item">
					<div class="icon">
						<!-- <img src="@/assets/email.png" alt="" /> -->
						<svg-icon name="email"></svg-icon>
					</div>
					<div class="value">{{ webInfo.email }}</div>
				</div>
				<div class="copyright" @click="tohangye">
					版权所有 {{ webInfo.copyright }}
				</div>
			</div>
			<div class="ercodes-box">
				<div class="label">关注我们</div>
				<div class="ercodes">
					<div class="code">
						<img src="@/assets/tmp/ercode-1.jpg" alt="" />
					</div>
					<div class="code">
						<img src="@/assets/tmp/ercode-2.jpg" alt="" />
					</div>
				</div>
			</div>
			<!-- <div class="menu">
				<router-link tag="div" class="menu-item" :to="{ path: '/feedback/index' }">意见反馈</router-link>
				<router-link tag="div" class="menu-item" :to="{ path: '/about/index', hash: 'pingtaijieshao'  }">平台介绍</router-link>
			</div> -->
		</div>
	</div>
</template>

<script>
import { webInfo } from '@/common/data.js';
export default {
	name: 'Foot',
	data() {
		return {
			webInfo: webInfo
		};
	},
	methods: {
		toHome(e) {
			this.$store.dispatch('delView', 'home').then(() => {
				this.$store.dispatch('addView', 'home')
				this.$router.push({ path: '/index', hash: 'top'  })
			})
		},
		tohangye() {
			window.open('https://www.chinaccia.com', '_blank');
		}
	}
};
</script>

<style lang="scss" scoped>
.foot-component {
	margin-top: auto;
	display: flex;
	height: $foot-height;
	background: #29965c;
	// background: #272C32;
	// background: $primary;
	.foot-container {
		display: flex;
		justify-content: space-between;
		// align-items: center;
		padding-top: 23px;
		.logo-link {
			align-self: center;
			margin-right: 125px;
			.logo {
				width: 220px;
				height: 47px;
			}
		}
		.fields {
			// flex: 1;
			display: flex;
			flex-direction: column;
			.label {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #FFFFFF;
				margin-bottom: 17px;
			}
			.fields-item {
				margin-top: 20px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #FFFFFF;
				line-height: 25px;
				cursor: pointer;
			}
			.menu {
				display: flex;
				margin-top: 30px;
				.menu-item {
					margin-right: 37px;
					font-size: 12px;
					color: #ffffff;
					line-height: 17px;
					cursor: pointer;
					position: relative;
					&:hover {
						top: -1px;
					}
				}
			}
		}
		.contacts {
			// flex: 1;
			display: flex;
			flex-direction: column;
			// margin-right: 180px;
			.label {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #FFFFFF;
				margin-bottom: 17px;
			}
			.item {
				display: flex;
				align-items: center;
				margin-bottom: 10px;
				.icon {
					width: 13px;
					height: 12px;
					margin-right: 8px;
					img {
						width: 100%;
						height: 100%;
					}
					.svg-icon {
						width: 100%;
						height: 100%;
					}
				}
				.value {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #FFFFFF;
				}
			}
			.copyright {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #FFFFFF;
				line-height: 17px;
				cursor: pointer;
			}
		}
		.ercodes-box {
			display: flex;
			flex-direction: column;
			.label {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #FFFFFF;
				margin-bottom: 17px;
				margin-left: 10px;
			}
			.ercodes {
				display: flex;
				.code {
					width: 82px;
					height: 82px;
					margin: auto 10px; 
					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
		// .menu {
		// 	display: flex;
		// 	align-self: center;
		// 	.menu-item {
		// 		margin-left: 37px;
		// 		font-size: 12px;
		// 		color: #ffffff;
		// 		line-height: 17px;
		// 		cursor: pointer;
		// 	}
		// }
	}
}
</style>
